<template>
  <div>
    <router-view></router-view>
  </div>
</template>

<script>

export default {
  name: 'App',
  components: {
  },
  data () {
    return {
    }
  },
  created() {

  },
  computed: {

  },
  methods: {
  },
  mounted() {

  }
}
</script>
